var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isUnread || _vm.isDateIndicator
    ? _c("div", [
        _vm.isDateIndicator
          ? _c(
              "small",
              {
                staticClass:
                  "justify-center flex align-center items-center font-bold w-full my-4",
                class: {
                  "error--text": _vm.isUnread,
                },
              },
              [
                _c("v-divider", {
                  staticClass: "flex",
                  attrs: { color: _vm.isUnread ? "error" : null },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "mx-4 soli-grey" }, [
                  _vm._v(_vm._s(_vm.date)),
                ]),
                _vm._v(" "),
                _c("v-divider", {
                  staticClass: "flex",
                  attrs: { color: _vm.isUnread ? "error" : null },
                }),
                _vm._v(" "),
                _vm.isUnread
                  ? _c(
                      "div",
                      { staticClass: "absolute right-0" },
                      [
                        _c("v-card", { attrs: { flat: "", white: "" } }, [
                          _c("div", { staticClass: "px-4 error--text" }, [
                            _vm._v("New"),
                          ]),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isUnread && !_vm.isDateIndicator
          ? _c(
              "small",
              {
                staticClass:
                  "justify-end flex align-center font-bold w-full my-4 error--text",
              },
              [
                _c("v-divider", {
                  staticClass: "flex",
                  attrs: { color: "error" },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "mx-4" }, [_vm._v("New")]),
              ],
              1
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }